export const agentAccountConfig = {
  //注意：这里的 key 会决定最后的接口参数名称，不能随便写
  projectName: {
    label: "项目名称",
    component: "el-input",
    attrs: {
      placeholder: "请输入内容"
    },
    options: [],
    style: {},
    event: {}
  },
  number: {
    label: "数量范围",
    component: "el-input-number",
    attrs: {
      name: ["purchaseMin", "purchaseMax"]
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  creator: {
    label: "创建人",
    component: "el-tree",
    attrs: {},
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  indicatorId: {
    label: "关联病理指标",
    component: "el-select",
    attrs: {},
    options: [
      {
        key: "选项1",
        value: "黄金糕"
      },
      {
        key: "选项2",
        value: "双皮奶"
      },
      {
        key: "选项3",
        value: "蚵仔煎"
      },
      {
        key: "选项4",
        value: "龙须面"
      }
    ],
    style: {},
    event: {}
  },
  beginTime: {
    label: "创建时间",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "至",
      valueFormat: "yyyy-MM-dd",
      name: ["activateTimeFrom", "activateTimeTo"]
    },
    // customPrefix: true,
    customContent: true, //日期选择器是需要自主个性化定制的，所以这个必须设置为 true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  dads: {
    label: "创建时间",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "至",
      valueFormat: "yyyy-MM-dd",
      name: ["acdasdTimeFrom", "acdsadaTimeTo"],
      rule: "required"
    },
    // customPrefix: true,
    customContent: true, //日期选择器是需要自主个性化定制的，所以这个必须设置为 true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  selsect2: {
    label: "关联病理指标2",
    component: "el-select",
    attrs: { multiple: true, placeholder: "多选框" },
    options: [
      {
        key: "选项1",
        value: "黄金糕"
      },
      {
        key: "选项2",
        value: "双皮奶"
      },
      {
        key: "选项3",
        value: "蚵仔煎"
      },
      {
        key: "选项4",
        value: "龙须面"
      }
    ],
    style: {},
    event: {}
  },
  selsect3: {
    label: "关联病理指标3",
    component: "el-select",
    attrs: {},
    options: [
      {
        key: "选项1",
        value: "黄金糕"
      },
      {
        key: "选项2",
        value: "双皮奶"
      },
      {
        key: "选项3",
        value: "蚵仔煎"
      },
      {
        key: "选项4",
        value: "龙须面"
      }
    ],
    style: {},
    event: {}
  },
  dadsTime: {
    label: "创建时间",
    component: "el-date-picker",
    attrs: {
      rangeSeparator: "至",
      valueFormat: "yyyy-MM-dd",
      name: ["aTimeFrom", "dTimeTo"]
    },
    // customPrefix: true,
    customContent: true, //日期选择器是需要自主个性化定制的，所以这个必须设置为 true
    // id: "start-time",
    type: "daterange",
    event: {},
    child: {}
  },
  //下面是两个特殊的！
  accountType: {
    label: "账户类型:",
    component: "el-select",
    attrs: {
      placeholder: "请选择账户类型",
      keyAsValue: true //用 key 当做 option 的 value
    },
    options: [],
    style: {},
    event: {}
  },
  payMethod: {
    label: "充值方式:",
    component: "el-select",
    attrs: {
      placeholder: "请选择",
      keyAsValue: true //用 key 当做 option 的 value
    },
    options: [],
    style: {},
    event: {}
  },
  createBy: {
    label: "操作人:",
    component: "el-select",
    attrs: {
      placeholder: "操作人",
      keyAsValue: true //用 key 当做 option 的 value
    },
    options: [],
    style: {},
    event: {}
  },
  creator: {
    label: "下级代理商:",
    component: "el-tree",
    attrs: {
      placeholder: "请选择代理商",
      treeType: "agent"
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  },
  //代理商本身自己一个
  campusIds: {
    label: "代理商",
    component: "el-tree",
    attrs: {
      placeholder: "请选择代理商",
      treeType: "agentSelf"
    },
    options: [],
    style: {},
    event: {},
    customContent: true
  }
};
